<template>
  <page-wrapper :title="'นัดหมายทั้งหมด'" :noPadBtm="true">
    <!-- Appointment dialog -->
    <div class="dialog-bg" v-if="isShowAppointmentMenu">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "นัดวันให้บริการ" }}</p>
          <div class="close-btn" @click="hideAppointmentMenu">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <p>{{ "วันที่" }}</p>
          <el-date-picker
            class="item"
            id="appointment_date"
            name="appointment_date"
            :placeholder="'ระบุวันที่'"
            type="date"
            format="dd MMMM yyyy"
            v-model="form.dateTime"
          />
          <p class="mt-2">{{ "เวลานัด" }}</p>
          <el-time-picker
            class="item"
            id="appointment_start_time"
            name="appointment_start_time"
            :placeholder="'00:00'"
            format="HH:mm"
            type="time"
            v-model="form.startTime"
          ></el-time-picker>
          <p class="mt-2">{{ "ถึง" }}</p>
          <el-time-picker
            class="item"
            id="appointment_end_time"
            name="appointment_end_time"
            :placeholder="'00:00'"
            format="HH:mm"
            type="time"
            v-model="form.endTime"
          ></el-time-picker>
          <!-- Open when the api is done. -->
          <!-- <p class="mt-2">
            {{ "บันทึกการนัดบริการ" }}
          </p>
          <el-input
            type="textarea"
            rows="3"
            placeholder="ระบุข้อความ"
            v-model="form.note"
          ></el-input> -->
          <div class="button-wrapper">
            <button class="mr-1 button cancel" @click="hideAppointmentMenu">
              {{ "ยกเลิก" }}
            </button>
            <button class="ml-1 button submit" @click="handleConfirmAppoint">
              {{ "บันทึก" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="content-wrapper" v-if="isDesktop">
      <div class="left">
        <user-info :appointment="appointment" v-if="appointment" />
        <registration-form
          :registrationForm="registrationForm"
          v-if="registrationForm"
        />
      </div>
      <div class="right">
        <appointment-history
          :subscriber="subscriber"
          :services="services"
          @expandBillingCycle="handleExpandBillingCycle"
          @appoint="handleAppoint"
          v-if="isShowAppointmentHistory"
        />
      </div>
    </div>
    <div class="content-wrapper" v-else>
      <appointment-history
        :subscriber="subscriber"
        :services="services"
        @expandBillingCycle="handleExpandBillingCycle"
        @appoint="handleAppoint"
        v-if="isShowAppointmentHistory"
      />
      <user-info :appointment="appointment" v-if="appointment" />
      <registration-form
        :registrationForm="registrationForm"
        v-if="registrationForm"
      />
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../components/SupplierPageWrapper";
import AppointmentHistory from "../components/AppointmentHistory";
import JobDetailUserInfo from "../components/JobDetailUserInfo";
import JobDetailRegistrationForm from "../components/JobDetailRegistrationForm";
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH, getDurationAppointmentTimeText } from "@/lib/dateTime";
import { DatePicker, TimePicker, Input } from "element-ui";
import { existValueAndEmptyString } from "@/lib/util";
import { DateTime } from "luxon";
import { mSize } from "../StaticVariable";

export default {
  components: {
    PageWrapper,
    "user-info": JobDetailUserInfo,
    "registration-form": JobDetailRegistrationForm,
    AppointmentHistory,
    "el-date-picker": DatePicker,
    "el-time-picker": TimePicker,
    "el-input": Input
  },
  data() {
    const providerId = localStorage.getItem("supplierProviderId");

    return {
      windowWidth: window.innerWidth,
      providerId,
      appointmentById: {},
      appointment: null,
      registrationForm: null,
      subscriber: null,
      services: [],
      showAppointment: false,
      form: {
        appointment: null,
        dateTime: null,
        startTime: null,
        endTime: null,
        note: null
      }
    };
  },
  created() {
    this.setup();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setup() {
      this.setupData();
    },
    async setupData() {
      await this.setupAppointments();
    },
    async setupAppointments() {
      try {
        const { appointment } = await this.fetchAppointmentDetail(
          this.appointmentId
        );
        this.appointment = appointment;

        const {
          registrationForm,
          subscriber
        } = await this.fetchSubscriberDetail(
          this.appointment.subscriptionMemberId
        );
        this.registrationForm = registrationForm;
        this.subscriber = subscriber;

        const fetchAppointmentsParams = { provider_id: this.providerId };
        const appointments = await this.fetchAppointments(
          this.appointment.subscriptionMemberId,
          fetchAppointmentsParams
        );
        this.appointmentById = this.groupBy(appointments, "service_id");

        this.updateServices();
      } catch (err) {
        console.error(err);
      }
    },
    updateServices() {
      this.services = this.subscriber.services
        .filter(service => service.providerId.toString() === this.providerId)
        .map(service => {
          const {
            id,
            name,
            description,
            shortDescription,
            iconUrl,
            type,
            quota,
            mainOption,
            extraOption
          } = service;

          const appointments = this.appointmentById[id].map(appointment => {
            const ISOdateTime = DateTime.fromISO(appointment.date_time);
            const time = getDurationAppointmentTimeText(
              appointment.date_time,
              appointment.date_time_end
            );

            const lastBillingCycle = this.subscriber.lastBillingCycle;
            let isDisableAppointment =
              appointment.is_disable_appointment_by_note_invoice;

            if (quota === 0) {
              isDisableAppointment = true;
            } else if (
              lastBillingCycle &&
              !lastBillingCycle.canMakeAppointment
            ) {
              isDisableAppointment = true;
            } else if (
              lastBillingCycle &&
              existValueAndEmptyString(
                lastBillingCycle.isDisableAppointmentByNoteInvoice
              )
            ) {
              isDisableAppointment =
                lastBillingCycle.isDisableAppointmentByNoteInvoice;
            }

            // disable ปุ่ม นัดหมาย ถ้าไม่ใช่การนัดครั้งแรกสุดที่ยังไม่ได้นัด
            let isDisableButton = false;

            // ซ่อนรอบบิลที่ไม่ใช่รอบบิลล่าสุด
            let isExpandBillingCycle = true;

            return {
              id: appointment.id,
              status: appointment.appointment_status,
              invoiceId:
                appointment.invoice_id !== undefined
                  ? appointment.invoice_id
                  : null,
              appointmentNo:
                appointment.appointment_no !== undefined
                  ? appointment.appointment_no
                  : null,
              date: toLocaleTH(ISOdateTime).toFormat("dd MMM yyyy"),
              time,
              route: !appointment.constraint.can_make_appointment
                ? {
                    name: "SupplierJobDetail",
                    params: { appointmentId: appointment.id }
                  }
                : null,
              constraint: {
                canMakeAppointment: appointment.constraint.can_make_appointment
              },
              note: appointment.appointment_note || "-",
              quota: quota,
              lastBillingCycle: lastBillingCycle,
              isDisableAppointment,
              isDisableButton,
              isExpandBillingCycle
            };
          });

          let histories = this.groupBy(appointments, "invoiceId");

          // enable appointment in each first appoint in each invoice
          Object.values(histories).forEach(history => {
            history.sort((a, b) => (a.date < b.date ? 1 : -1));
            history.sort((a, b) =>
              a.appointmentNo > b.appointmentNo ? 1 : -1
            );

            Object.values(history).forEach((appointment, index) => {
              if (appointment.isDisableAppointment === true) {
                appointment.isDisableButton = true;
              } else if (!appointment.constraint.canMakeAppointment) {
                appointment.isDisableButton = true;
              } else if (
                index === 0 ||
                Object.values(history)[index - 1].date !== "Invalid DateTime"
              ) {
                appointment.isDisableButton = false;
              } else {
                appointment.isDisableButton = true;
              }
            });
          });

          return {
            id,
            data: {
              id,
              iconUrl,
              name,
              description,
              shortDescription,
              type,
              mainOption,
              extraOption,
              quota
            },
            appointments,
            histories
          };
        });
    },
    handleExpandBillingCycle(selectedAppointment) {
      const services = this.services.map(service => {
        const appointments = service.appointments.map(appointment => {
          const isExpandBillingCycle =
            appointment.id === selectedAppointment.id
              ? !appointment.isExpandBillingCycle
              : appointment.isExpandBillingCycle;

          return {
            ...appointment,
            isExpandBillingCycle: isExpandBillingCycle
          };
        });

        const histories = Object.values(service.histories).map(item => {
          const history = item.map(appointment => {
            const isExpandBillingCycle =
              appointment.id === selectedAppointment.id
                ? !appointment.isExpandBillingCycle
                : appointment.isExpandBillingCycle;

            return {
              ...appointment,
              isExpandBillingCycle: isExpandBillingCycle
            };
          });

          return history;
        });

        return {
          ...service,
          histories,
          appointments
        };
      });

      this.services = services;
    },
    handleAppoint(appointment) {
      this.form.appointment = appointment;

      this.showAppointmentMenu();
    },
    async handleConfirmAppoint() {
      const { dateTime, startTime, endTime, note } = this.form;

      if (!dateTime || !startTime) {
        alert(`กรุณาเลือกวันที่ และเวลานัด`);
        return;
      }

      this.hideAppointmentMenu();

      try {
        const { id: appointmentId } = this.form.appointment;

        const dateTimeFormat = DateTime.fromJSDate(dateTime);
        const startDateTime = toLocaleTH(dateTimeFormat).set({
          hours: startTime.getHours(),
          minutes: startTime.getMinutes()
        });
        const endDateTime = endTime
          ? toLocaleTH(dateTimeFormat).set({
              hours: endTime.getHours(),
              minutes: endTime.getMinutes()
            })
          : undefined;

        const params = {
          date_time: startDateTime,
          date_time_end: endDateTime,
          note: note || undefined
        };

        await this.appoint(appointmentId, params);

        this.form.appointment = null;
        this.form.dateTime = null;
        this.form.startTime = null;
        this.form.endTime = null;
        this.form.note = null;

        this.setupData();
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถนัดวันได้");
      }
    },
    groupBy(lists, key) {
      return lists.reduce(function(group, element) {
        (group[element[key]] = group[element[key]] || []).push(element);
        return group;
      }, {});
    },
    showAppointmentMenu() {
      this.showAppointment = true;
    },
    hideAppointmentMenu() {
      this.showAppointment = false;
    },
    async fetchAppointmentDetail(appointmentId) {
      return await baanRueJaiClient.others.supplier.getProviderAppointmentDetail(
        appointmentId
      );
    },
    async fetchSubscriberDetail(subscriptionMemberId) {
      return await baanRueJaiClient.others.supplier.getSubscriberDetail(
        subscriptionMemberId
      );
    },
    async fetchAppointments(subscriptionMemberId, params) {
      return await baanRueJaiClient.others.supplier.getAppointments(
        subscriptionMemberId,
        params
      );
    },
    async appoint(appointmentId, params) {
      return await baanRueJaiClient.others.supplier.appoint(
        appointmentId,
        params
      );
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize;
    },
    appointmentId() {
      return this.$route.params.appointmentId;
    },
    isShowAppointmentHistory() {
      return this.subscriber && this.services;
    },
    isShowAppointmentMenu() {
      return this.showAppointment;
    }
  },
  watch: {
    "form.dateTime": function(value) {
      if (!value) {
        this.form.dateTime = null;
        this.form.startTime = null;
        this.form.endTime = null;

        return;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 100%;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;

      p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      padding: 16px;
      > .item {
        width: 100%;
      }

      > .el-date-editor.el-input,
      > .el-date-editor.el-input__inner {
        width: 100%;
      }

      > .button-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;

        > .button {
          flex: 1;
          padding-inline: 16px;
          height: 44px;
          font-weight: bold;
          font-size: $font-16;
          border-radius: 8px;
          border: none;
        }

        > .cancel {
          color: $black;
          background: transparent;
          border: 1px solid $color-light-gray-1;
          margin-right: 4px;

          &:hover:not(:disabled) {
            background: $color-light-gray-1-hover;
          }
        }

        > .submit {
          color: $white;
          background: $supplier-primary-color;
          margin-left: 4px;

          &:hover:not(:disabled) {
            background: $supplier-primary-light-color;
          }
        }
      }

      .el-textarea,
      .el-input {
        font-size: $font-16;
      }
    }
  }
}

.content-wrapper {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: calc(28% - 12px) calc(72% - 12px);
  grid-gap: 24px;
  padding: 24px;

  > .left {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }

  > .right {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }
}

@media (max-width: ($m-size - 1)) {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
    padding: 16px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(38% - 8px) calc(62% - 8px);
    grid-gap: 16px;
    padding: 16px;

    > .left {
      grid-gap: 16px;
    }

    > .right {
      grid-gap: 16px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(28% - 6px) calc(72% - 6px);
    grid-gap: 12px;
    padding: 12px;

    > .left {
      grid-gap: 12px;
    }

    > .right {
      grid-gap: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/pages/AppointmentList.vue